import { MouseEvent, useCallback, useEffect, useRef, useState } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { Menu } from './Menu'

// import { AdminSettings } from './AdminSettings'
import { Users } from './Users'
import { Mountpoints } from './Mountpoints'
import Measurments from './Measurments'
// import { LogViewer } from 'log-viewer/LogViewer'
// import { Permissions } from './Permissions'
import { UserProfile } from './UserProfile'
import { UserStats } from './UserStats'
import { MountpointInfo } from './MountpointInfo'
import { MountpointStats } from './MountpointStats'
// import MountpointSatellites from './MountpointSatellites'
// import SatellitesCount from './MountpointSatellitesHistory/SatellitesCount'
// import SatelliteSignals from './MountpointSatellitesHistory/SatelliteSignals'
// import { Server } from './Server'
import { Analytics } from './Analytics'
import { Events } from './Events'

import { useMediaQuery } from '@material-ui/core'
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles'
// import RinexList from './RinexService/RinexList'
import MapStatusBar from 'Map/MapStatusBar'
// import UserHistory from './UserHistory'
// import RinexForm from './RinexService/RinexForm'
import MountpointLogs from './MountpointLogs'
import { useToken } from 'App'

const SIDE_WIDTH_STORAGE_KEY = 'raycaster.sideWidth'
const SIDE_MIN_WIDTH = 450
const SIDE_MAX_WIDTH = 900
const SIDE_DEFAULT_WIDTH = 480

function readStoredWidth(): number {
  const raw = localStorage.getItem(SIDE_WIDTH_STORAGE_KEY)
  if (!raw) return SIDE_DEFAULT_WIDTH
  const n = parseInt(raw, 10)
  if (isNaN(n)) return SIDE_DEFAULT_WIDTH
  return Math.max(SIDE_MIN_WIDTH, Math.min(SIDE_MAX_WIDTH, n))
}

export function Side() {
  const theme = useTheme()
  const isRTL = theme.direction === 'rtl'
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { ut: userRole } = useToken()
  const isAdmin = userRole === 'admin'
  const isOperator = userRole === 'operator'
  const isAnalyticsRoute = !!useRouteMatch('/analytics')
  // const isLogsRoute = !!useRouteMatch('/logs')
  const isEventsRoute = !!useRouteMatch('/events')
  const isFullWidth =
    (isAdmin && isAnalyticsRoute) ||
    ((isAdmin || isOperator) && isEventsRoute)
  const [width, setWidth] = useState<number>(() => readStoredWidth())
  const draggingRef = useRef(false)
  const classes = useStyles({ width, isMobile, isFullWidth })

  const onMouseDown = useCallback((e: MouseEvent) => {
    e.preventDefault()
    draggingRef.current = true
    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }, [])

  useEffect(() => {
    const onMove = (e: globalThis.MouseEvent) => {
      if (!draggingRef.current) return
      const raw = isRTL ? window.innerWidth - e.clientX : e.clientX
      const next = Math.max(SIDE_MIN_WIDTH, Math.min(SIDE_MAX_WIDTH, raw))
      setWidth(next)
    }
    const onUp = () => {
      if (!draggingRef.current) return
      draggingRef.current = false
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
      localStorage.setItem(SIDE_WIDTH_STORAGE_KEY, String(width))
    }
    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
    return () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
    }
  }, [width, isRTL])

  return (
    <div className={classes.root}>
      <Menu />
      <MapStatusBar />
      <div className={classes.content}>
        <Switch>
          {/* <Route path="/admin-settings" component={AdminSettings} /> */}
          <Route path="/users" component={Users} />
          {/* <Route path="/rinex/new" component={RinexForm} /> */}
          {/* <Route path="/rinex/list" component={RinexList} /> */}
          <Route path="/mountpoints" component={Mountpoints} />
          <Route path="/measurement" component={Measurments} />
          {/* <Route path="/logs" component={LogViewer} /> */}
          {/* <Route path="/permissions" component={Permissions} /> */}
          <Route path="/user/:userId/profile" component={UserProfile} />
          <Route path="/user/:userId/stats" component={UserStats} />
          {/* <Route path="/user/:userId/history" component={UserHistory} /> */}
          <Route path="/mountpoint/:mid/stats" component={MountpointStats} />
          {/* <Route
            path="/mountpoint/:mid/satellites"
            component={MountpointSatellites}
          /> */}
          {/* <Route
            path="/mountpoint/:mid/satellites-count"
            component={SatellitesCount}
          /> */}
          {/* <Route
            path="/mountpoint/:mid/satellite-signals"
            component={SatelliteSignals}
          /> */}
          <Route path="/mountpoint/:mid/info" component={MountpointInfo} />
          {!isOperator && (
            <Route path="/mountpoint/:mid/logs" component={MountpointLogs} />
          )}
          {/* <Route path="/server" component={Server} /> */}
          {isAdmin && <Route path="/analytics" component={Analytics} />}
          {(isAdmin || isOperator) && (
            <Route path="/events" component={Events} />
          )}
        </Switch>
      </div>
      {!isMobile && !isFullWidth && (
        <div
          className={classes.resizer}
          onMouseDown={onMouseDown}
          role="separator"
          aria-orientation="vertical"
          aria-label="Resize side panel"
        />
      )}
    </div>
  )
}

const useStyles = makeStyles<
  Theme,
  { width: number; isMobile: boolean; isFullWidth: boolean }
>((theme) => ({
  root: {
    position: 'fixed',
    width: ({ width, isMobile, isFullWidth }) =>
      isMobile || isFullWidth ? '100%' : width,
    maxHeight: '100dvh',
    display: 'flex',
    flexFlow: 'column',
    padding: theme.spacing(1),
    left: 0,
    zIndex: 5,
    boxSizing: 'border-box',
  },
  content: {
    width: '100%',
    maxHeight: `calc(100dvh - 48px - ${theme.spacing(3)}px)`, // minus height of menu
    marginTop: 3,
    display: 'flex',
    flexFlow: 'column',
    overflow: 'hidden',
  },
  resizer: {
    position: 'absolute',
    top: 0,
    right: -5,
    width: 10,
    height: '100%',
    cursor: 'col-resize',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&::before': {
      content: '""',
      width: 3,
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      transition: 'background-color 120ms ease, width 120ms ease',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: 4,
      height: 40,
      borderRadius: 2,
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
      transition: 'background-color 120ms ease, height 120ms ease',
    },
    '&:hover::before, &:active::before': {
      width: 5,
      backgroundColor: 'rgba(25, 118, 210, 0.35)',
    },
    '&:hover::after, &:active::after': {
      height: 56,
      backgroundColor: 'rgba(25, 118, 210, 0.85)',
    },
  },
}))
